<div class="progressBar progressBarSlider  height-10px w-95pc no-padding-right-left margin-top-15">
  <p *ngIf="isCompleted">
    <ngb-progressbar type="success" height="10px"  [value]="value" [max]="total">
    </ngb-progressbar>
  </p>
  <p *ngIf="!isCompleted">
      <ngb-progressbar type="warning" height="10px"  [value]="value" [max]="total">
      </ngb-progressbar>
    </p>
</div>